import { Avatar } from '@/shared/ui/avatar'
import { Badge } from '@/shared/ui/badge'
import { Icon } from '@/shared/ui/icon'
import type { Employee } from '../model/types'

interface EmployeeSummaryProps {
  employee: Employee
}

export function EmployeeSummary({ employee }: EmployeeSummaryProps) {
  return (
    <div className="flex items-center gap-3 rounded-card bg-bg-surface px-5 py-4 transition-colors hover:bg-bg-raised">
      <Avatar name={employee.full_name} size="sm" className="shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate font-medium text-text-primary">{employee.full_name}</span>
          {!employee.is_active && <Badge tone="danger">Деактивирован</Badge>}
          {employee.role === 'admin' && <Badge tone="accent">Админ</Badge>}
          {/* Помечаем только отсутствие связки: алерты такому сотруднику не дойдут,
              а привязка — норма и рябить бейджем по всему списку не должна. */}
          {!employee.telegram_linked && <Badge tone="warning">Без Telegram</Badge>}
        </div>
        <div className="mt-0.5 truncate text-xs text-text-tertiary">{employee.email}</div>
      </div>
      <Icon name="chevron-right" size={16} className="shrink-0 text-text-tertiary" />
    </div>
  )
}
